import _ from "underscore";

export const isAddonsChanged = (oldPlanAddons, newPlanAddons) => {
    if (!oldPlanAddons?.length && !newPlanAddons?.length)
        return false;

    const initialAddons = oldPlanAddons
        ?.map(companyAddon => ({
            type: companyAddon.type,
            quantity: companyAddon.quantity,
        }))
        .filter(addon => addon.quantity !== 0) || [];
    const selectedAddons = newPlanAddons
        ?.map(pack => _.pick(pack, ['type', 'quantity']))
        .filter(addon => addon.quantity !== 0) || [];
    // console.log('aaa isAddonsChanged', {initialAddons, selectedAddons});

    const sortedInitital = _.sortBy(initialAddons, 'type');
    const sortedSelected = _.sortBy(selectedAddons, 'type');
    return !_.isEqual(sortedInitital, sortedSelected);
};
